// Parse a Google Geocoder / Places result (address_components based) into the
// structured address fields used by the create-order location step.

const getComponent = (components, type, useShort = false) => {
    const found = (components || []).find((c) => c.types && c.types.includes(type));
    if (!found) return '';
    return useShort ? found.short_name : found.long_name;
};

// `result` is a single google.maps.GeocoderResult.
// Returns { city, street, buildingNumber, postalCode, address }.
export const parseGooglePlace = (result) => {
    if (!result) {
        return {city: '', street: '', buildingNumber: '', postalCode: '', address: ''};
    }

    const components = result.address_components || [];

    // In Ukraine the populated place usually comes back as `locality`; fall back
    // to administrative levels when a settlement is not tagged as a locality.
    const city =
        getComponent(components, 'locality') ||
        getComponent(components, 'administrative_area_level_2') ||
        getComponent(components, 'administrative_area_level_1') ||
        getComponent(components, 'postal_town');

    const street = getComponent(components, 'route');
    const buildingNumber = getComponent(components, 'street_number');
    const postalCode = getComponent(components, 'postal_code');
    const address = result.formatted_address || '';

    return {city, street, buildingNumber, postalCode, address};
};
